App.vue.setComponent(require('@components/Catalog/CatalogNotFound.vue').default);
App.vue.setComponent(require('@components/Catalog/Catalog.vue').default);
App.vue.setComponent(require('@components/Product/sliders/ProductSliderRevised.vue').default);
App.vue.setComponent(require('@components/Catalog/CatalogNotFoundBanner.vue').default);
App.vue.setComponent(require('@components/Stocks/StocksCatalog.vue').default);
